import RegistrationStepsRoute from "./RegistrationStepsRoute";
export default RegistrationStepsRoute;



// WEBPACK FOOTER //
// ./src/components/RegistrationStepsRoute/index.js